/**
 * La FORME 3D de chaque trousse du catalogue. Trois formes :
 *  - `boite`     : la trousse rigide à couvercle du prototype (zip tout autour, crayons dedans) ;
 *  - `berlingot` : la trousse souple en prisme (base large, zip sur l'arête du haut, pompon) ;
 *  - `tube`      : la trousse cylindrique (embouts de couleur, zip sur le dessus, passants).
 *
 * La répartition a été TIRÉE AU SORT une fois (mélange au hasard des 32 slugs, puis une forme sur
 * trois : 11 / 11 / 10) et figée ici — une trousse garde donc sa forme d'un chargement à l'autre.
 * Un slug inconnu prend une forme tirée de son nom. PUR.
 */

export const TROUSSE_SHAPES = ['boite', 'berlingot', 'tube'] as const;
export type TrousseShape = (typeof TROUSSE_SHAPES)[number];

export const SLUG_SHAPE: Record<string, TrousseShape> = {
  graphite: 'tube',
  craie: 'berlingot',
  'bois-clair': 'boite',
  'nuit-douce': 'boite',
  'camo-bleu': 'tube',
  'camo-kaki': 'berlingot',
  damier: 'boite',
  'nid-abeille': 'tube',
  tricolore: 'berlingot',
  feuillage: 'boite',
  marguerites: 'berlingot',
  paquerettes: 'boite',
  'vagues-pastel': 'boite',
  coeurs: 'berlingot',
  avocats: 'berlingot',
  hibiscus: 'berlingot',
  lagon: 'boite',
  rentree: 'boite',
  manette: 'tube',
  idees: 'tube',
  formules: 'berlingot',
  neon: 'berlingot',
  'soleil-couchant': 'tube',
  'nuages-rouges': 'tube',
  flammes: 'berlingot',
  'grande-vague': 'tube',
  planetes: 'tube',
  saturne: 'boite',
  galaxie: 'berlingot',
  'marbre-noir': 'boite',
  'origami-rouge': 'tube',
  'marbre-or': 'boite',
};

function hash(s: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h;
}

export function shapeForSlug(slug: string): TrousseShape {
  return SLUG_SHAPE[slug] ?? TROUSSE_SHAPES[hash(slug) % TROUSSE_SHAPES.length]!;
}
